import { stats } from "../config"

const Statistic = () => {
    return (
        <section className="grid grid-flow-col grid-cols-2 grid-rows-2 gap-5 md:flex md:justify-evenly md:items-center px-5 md:px-32 py-14 md:py-32">
            {stats.map(stat => (
                <div key={stat.id} className="flex flex-col items-center">
                    <h4 className="text-xl font-bold text-primary">{stat.title}</h4>
                    <p className="font-light text-gray-300">{stat.desc}</p>
                </div>
            ))}
        </section>
    )
}

export default Statistic